<span class="badge" *ngIf="eventoData"
  [ngStyle]="{
    'background-color': eventoData.backgroundColor,
    'border-color': eventoData.color,
    'color': eventoData.color
  }"
  [title]="eventoData.description"
  >
  {{eventoData.name}}
</span>